import { useMemo } from "react";
import * as Yup from "yup";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";

export const useApplyWithProfileSchema = () => {
  const L = useLocStore(LocContext.CV);

  const APPLY_WITH_PROFILE_VALIDATION = useMemo(() => {
    return Yup.object().shape({
      applicationText: Yup.string().required(
        L.id("f717b88c7a00").loc("Du må skrive en søknadstekst")
      ),
      consent5000: Yup.boolean().required(
        L.id("d802514613ce").loc("Du må akseptere samtykkeerklæringen")
      ),
      attachments: Yup.array().of(Yup.mixed()),
    });
  }, [L.changeIndicator]);

  return { APPLY_WITH_PROFILE_VALIDATION };
};

// Explicitly define the interface so that ts does not complain about missing properties
export interface ApplyWithProfileFormValues {
  applicationText: string;
  consent5000: boolean;
  attachments: File[];
}
